export default __webpack_public_path__ + "static/media/Options.e20bb9da.svg";